import type { Product } from '../../../data/product';
import { preciseCurrencyFormatter } from '../../../helpers/format-currency';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const LastCaseCost: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Last Case Cost',
  minWidth: 60,
  accessorFn: (product) => preciseCurrencyFormatter(product.last_cost * product.case_qty),
  toCSV: (product) => ({
    'Last Case Cost': product.last_cost.toFixed(2),
  }),
});
